export const routes = {
  root: '/',
  draft: '/applications',
  landing: '/landing',
  programs: '/programs',
  instructions: '/intro/:id',
  pgForm: '/pgForm',
  treeView: '/treeView',
  thankYou: '/thankyou',
  sidenav: '/form/:id',
};

export const endPoints = {};

export const urls = {
  paytm: 'https://securegw-stage.paytm.in/order/process',
};
